function mtInitReveals() {
  const els = document.querySelectorAll('.mt-reveal:not(.mt-observed)');
  if (!els.length) return;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) {
    els.forEach((el) => el.classList.add('mt-visible'));
    return;
  }
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );
  els.forEach((el) => {
    el.classList.add('mt-observed');
    observer.observe(el);
  });
}

function mtInitCountUp() {
  const els = document.querySelectorAll('.mt-countup:not(.mt-observed)');
  if (!els.length) return;
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        const target = parseFloat(el.dataset.target || '0');
        const suffix = el.dataset.suffix || '';
        const duration = 1400;
        const start = performance.now();
        function step(now) {
          const p = Math.min((now - start) / duration, 1);
          const eased = 1 - Math.pow(1 - p, 3);
          const value = target * eased;
          el.textContent = (Number.isInteger(target) ? Math.round(value) : value.toFixed(1)) + suffix;
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
        observer.unobserve(el);
      });
    },
    { threshold: 0.5 }
  );
  els.forEach((el) => {
    el.classList.add('mt-observed');
    observer.observe(el);
  });
}

function mtInitPasos() {
  const wraps = document.querySelectorAll('.mt-pasos:not(.mt-observed)');
  wraps.forEach((wrap) => {
    wrap.classList.add('mt-observed');
    const tabs = wrap.querySelectorAll('.mt-paso-tab');
    const panels = wrap.querySelectorAll('.mt-paso-panel');
    if (!tabs.length) return;
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => {
        tabs.forEach((t) => t.classList.remove('is-active'));
        panels.forEach((p) => p.classList.remove('is-active'));
        tab.classList.add('is-active');
        if (panels[i]) panels[i].classList.add('is-active');
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  mtInitReveals();
  mtInitCountUp();
  mtInitPasos();
});

document.addEventListener('shopify:section:load', () => {
  mtInitReveals();
  mtInitCountUp();
  mtInitPasos();
});
